import { SettingOutlined } from '@ant-design/icons';
import styles from 'layouts/main/LayoutMain.module.scss';
import { useTranslation } from 'react-i18next';
import { useUserStore } from 'store/user';
import type { TComponent } from 'utils/types/component';

export const ChangePasswordButton: TComponent = () => {
    const changePassword = useUserStore('changePassword');

    const { t } = useTranslation();

    return (
        <div
            onClick={changePassword}
            className={styles.menuItemButtonContainer}
        >
            <SettingOutlined />
            <span className={styles.settingText}>
                {t('common.buttons.changePassword')}
            </span>
        </div>
    );
};
